export default __webpack_public_path__ + "assets/front/scss/classification-browsing.2fb9c7fbc0d9e0a051cfd083b55dc6ed.css";